import { useCallback, useLayoutEffect } from 'react'
import { Button } from '@mui/material'
import { useSnackbar } from '@ui/snackbar'
import { useControlStore } from '@editorStores'

const useSelectionMode = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const toggleSelectionMode = useControlStore(state => state.toggleSelectionMode)
  const selectionMessage = useControlStore(state => state.selectionMessage)
  const selectionModeKey = useControlStore(state => state.selectionModeKey)
  const selectionAbortCallback = useControlStore(state => state.selectionAbortCallback)

  useLayoutEffect(() => {
    if (selectionMessage) {
      enqueueSnackbar(selectionMessage, {
        key: selectionMessage,
        variant: 'info',
        persist: true,
        preventDuplicate: true,
        action: () => (
          <span
            style={{
              color: '#fff',
            }}
          >
            <Button
              variant="outlined"
              size="small"
              color="inherit"
              onClick={event => {
                event.stopPropagation()

                toggleSelectionMode()
                selectionAbortCallback?.()
              }}
            >
              Abbrechen
            </Button>
          </span>
        ),
      })

      return () => {
        closeSnackbar(selectionMessage as string)
        selectionAbortCallback?.()
      }
    }
  }, [
    closeSnackbar,
    enqueueSnackbar,
    selectionAbortCallback,
    selectionMessage,
    toggleSelectionMode,
  ])

  const unsetSelectionMode = useCallback(() => {
    toggleSelectionMode()
    selectionAbortCallback?.()
  }, [selectionAbortCallback, toggleSelectionMode])

  return {
    selectionModeKey,
    isSelectionMode: !!selectionMessage,
    setSelectionMode: toggleSelectionMode,
    unsetSelectionMode,
  }
}

export default useSelectionMode
